var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-skills"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"header-skills_user-info"},[_c('label',[_vm._v("Colaborador:")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.collaborator))])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }